"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Salesviewer_1 = __importDefault(require("../Salesviewer/Salesviewer"));
const GAnalytics_1 = __importDefault(require("../Analytics/GAnalytics"));
require("./CookieBanner.css");
var langBundle = {
    "de": {
        "title": "Datenschutzeinstellungen",
        "maintext": "Auf unserer Webseite werden Cookies und weitere Funktionen verwendet, mit welchen Endgeräteinformationen und personenbezogene Daten unserer \
Nutzer verarbeitet werden. Einige davon werden zwingend benötigt, während andere der statistischen Analyse oder der Unternehmenszuordnung dienen. \
Dabei werden auch Daten an Dritte weitergegeben und dort verarbeitet. Informationen zu den einzelnen Funktionen, den Empfängern der Daten, der \
Verarbeitung in den USA und der Speicherdauer finden Sie unter „Weitere Informationen“. Diese Einwilligung ist freiwillig, für die Nutzung unserer \
Webseite nicht erforderlich und kann jederzeit für die Zukunft unter <a href=\"https://otools.ktr.com/otools/DatenschutzDE.html\" target=\"_blank\"> „Datenschutzeinstellungen“</a> widerrufen werden. Die Einwilligung \
gilt, bis sie widerrufen wird. Im Folgenden können Sie mit einem Klick sämtliche Funktionen akzeptieren, die von Ihnen getroffene Auswahl \
speichern und schließen oder nur essentielle Cookies akzeptieren.",
        "essential": "Essentiell",
        "statistics": "Statistiken",
        "marketing": "Marketing",
        "external": "Externe Inhalte",
        "acceptAll": "Alle akzeptieren",
        "acceptSave": "Speichern & schließen",
        "acceptEssential": "Nur essentielle Cookies akzeptieren",
        "descEssential": "Essentielle Cookies werden für grundlegende Funktionen der Webseite benötigt. Dadurch ist gewährleistet, dass die Webseite einwandfrei funktioniert.",
        "descStatistics": "Statistische Analyse ist die Verarbeitung und Darstellung von Daten über Nutzeraktionen und -interaktionen \
auf unserer Webseite (z.B. Anzahl der Seitenbesuche, Anzahl der eindeutigen Besucher, Anzahl der wiederkehrenden Besucher, Einstiegs- und Ausstiegsseiten, \
Verweildauer, Absprungrate, Betätigung von Schaltflächen) und ggf. die Einteilung von Nutzern in Gruppen aufgrund technischer Daten über \
die verwendeten Softwareeinstellungen (z.B. Browsertyp, Betriebssystem, Spracheinstellung, Bildschirmauflösung).",
        "descMarketing": "Marketing ist eine Funktionalität, welche mittels eines Trackingskriptes die Zuordnung eines unbekannten Nutzers zu dessen dahinterstehenden Unternehmen ermöglicht.",
        "descExternal": "",
        "name": "Name",
        "provider": "Anbieter",
        "duration": "Laufzeit",
        "goal": "Zweck",
        "descCookie1": "Enthält die gewählten Tracking-Optin-Einstellungen.",
        "durationCookie1": "1 Jahr",
        "descCookie2": "Der Webanalysedienst „Google Analytics“ verwendet Technologien wie „Cookies“, „Tracking-Pixel“ und „Device Fingerprinting“, um ein bestimmtes Nutzerverhalten \
auf Webseiten nachzuvollziehen. Dabei werden auch Informationen verarbeitet, die auf den Endgeräten von Nutzern gespeichert werden. Mithilfe der in Webseiten eingebundenen „Tracking-Pixel“ und \
den auf Endgeräten von Nutzern abgelegten „Cookies“ verarbeitet „Google“ die erzeugten Informationen über die Benutzung unserer Webseite durch Endgeräte von Nutzern – z.B. dass eine \
bestimmte Webseite aufgerufen wurde – und Zugriffsdaten zum Zwecke der statistischen Analyse der Webseiten-Nutzung. Zu den Zugriffsdaten zählen insbesondere die IP-Adresse, \
Browserinformationen, die zuvor besuchte Webseite sowie Datum und Uhrzeit der Serveranfrage. „Google Analytics“ wird mit der Erweiterung „anonymizeIp()“ verwendet. Dadurch werden \
IP-Adressen gekürzt weiterverarbeitet, um eine Personenbeziehbarkeit deutlich zu erschweren. Die IP-Adressen werden laut Angaben von „Google“ innerhalb von Mitgliedstaaten der \
Europäischen Union zuvor gekürzt.\
<br/><b>Drittstaatentransfer</b>: Die Einwilligung für Google Analytics umfasst auch die Einwilligung in eine mögliche übermittlung der Daten in die USA ohne angemessenes Datenschutzniveau \
und ohne geeignete Garantien (fehlende Durchsetzbarkeit von Betroffenenrechten, fehlende Rechtsschutzmöglichkeiten und mögliche, unverhältnismäßige Zugriffe staatlicher \
Stellen auf die Daten der Nutzer). Die Nutzung von Google Analytics setzt den Drittstaatentransfer voraus. Wenn Sie dem Drittstaatentransfer nicht zustimmen möchten, müssen Sie \
Google Analytics abwählen.",
        "durationCookie2": "1 Jahr",
        "descCookie3": "Dieses Cookie wird von Google Analytics installiert. Das Cookie wird verwendet, um Informationen darüber zu speichern, wie Besucher eine Website nutzen, und hilft bei der Erstellung eines Analyseberichts darüber, wie es der Website geht. Die erhobenen Daten umfassen die Anzahl der Besucher, die Quelle, aus der sie stammen, und die Seiten in anonymisierter Form.",
        "durationCookie3": "1 Tag",
        "descCookie4": "Diese Funktion beinhaltet ein Trackingskript des Anbieters SalesViewer, welches die Zuordnung eines unbekannten Nutzers zu dessen dahinterstehenden Unternehmen ermöglicht. \
Die SalesViewer®-Technologie setzt einen javascript-basierten Code ein, der zur Erhebung unternehmensbezogener Daten und der entsprechenden Nutzung dient. Die mit dieser Technologie erhobenen Daten werden \
über eine nicht rückrechenbare Einwegfunktion (sog. Hashing) verschlüsselt. Die Daten werden unmittelbar pseudonymisiert und nicht dazu benutzt, den Besucher dieser Webseite persönlich zu \
identifizieren. Es erfolgt jedoch eine Identifikation des jeweils hinter dem Nutzer stehenden Unternehmens, welchem anschließend allgemeine Unternehmenskontaktdaten, die Branche sowie Angaben \
zum konkreten Verhalten des Nutzers auf der Webseite zugeordnet werden.",
        "durationCookie4": "24 Monate",
        "showCookieInfo": "Cookie-Informationen",
        "showMoreInfo": "Weitere Informationen",
        "privacy": "Datenschutz",
        "impressum": "Impressum",
        "urlPrivacy": "https://otools.ktr.com/otools/DatenschutzDE.html",
        "urlImpressum": "https://www.ktr.com/de/impressum/?disabledOptIn=1",
    },
    "en": {
        "title": "Data protection settings",
        "maintext": 'On our website, cookies and other functions are used, and these carry out the processing of our users’ terminals information and \
personal data. Some of them are urgently needed, whilst others fulfil the function of incorporating external elements, statistical analysis, \
company attribution or reach measurement. And, in the process, some data is also forwarded to third-party centres, where the data is processed. \
You can find the details concerning individual functions, concerning the recipients of data, concerning processing in the USA and concerning the \
storage period, under “Further information“. This consent is elective; it is not a pre-requisite for using our website and it can be revoked at \
any time with future effect under <a href=\"https://otools.ktr.com/otools/DataprotectionEN.html\" target=\"_blank\"> „Data protection settings“</a>.\
Consent remains valid until revoked. Below, you can apply a single click to accept \
all functions, to save the selection you have made, and then close; or otherwise accept only essential cookies.',
        "essential": "Essential",
        "statistics": "Statistics",
        "marketing": "Marketing",
        "external": "External content",
        "acceptAll": "Accept all",
        "acceptSave": "Save & Close",
        "acceptEssential": "Accept only essential cookies",
        "descEssential": "Essential cookies are required for basic functions of the website. This ensures that the website functions properly.",
        "descStatistics": "Statistical analysis is the processing and display of data concerning user actions and interactions on our website \
(e.g. quantity of visits to page, quantity of definite visitors, quantity of returning visitors, joining and leaving times, visit duration, bounce rate, \
actuation of buttons) and – where applicable, the classification of users into groups according to technical details affecting the employed software \
settings (e.g. browser type, operating system, language setting, screen resolution).",
        "descMarketing": "Marketing is a functionality that enables the assignment of an unknown user to the company behind it by means of a tracking script.",
        "descExternal": "",
        "name": "Name",
        "provider": "Provider",
        "duration": "Lifetime",
        "goal": "Purpose",
        "descCookie1": "Stores the chosen tracking optin settings.",
        "durationCookie1": "1 year",
        "descCookie2": "The “Google Analytics” web analysis service uses technologies such as “cookies”, “tracking pixels” and “device fingerprinting” in order to gain an understanding of \
certain user behaviour on websites. This will also involve the processing of information which is stored on users’ terminals. Drawing upon the “tracking pixels” incorporated in websites, together \
with the “cookies” deposited on users’ terminals, “Google” will process the generated information concerning the utilisation of our website by users’ terminals – assuming that a given website \
is accessed – together with access data for purposes of statistical analysis of website use. The access data will include, in particular, the IP address, browser information, the previously \
visited website and the date and time of the server request. “Google Analytics” is used with the extension “anonymizeIp()”. Accordingly, IP addresses are further processed in order to make \
it substantially difficult to identify any individuals. According to information from “Google”, IP addresses are pre-abbreviated within European Union member states.\
<br/><b>Third-party country transfer:</b>Consent for Google Analytics also includes consent for the possibility of the data being transferred to the USA without a reasonable level of data \
protection and without adequate guarantees (lack of enforceability of data subjects’ rights, lack of legal protection options and the possibility of disproportionate intervention with \
users’ data by governmental sources). The utilisation of Google Analytics presupposes third-party country transfer. If you do not wish to approve third-party country transfer, then you \
will need to deselect Google Analytics",
        "durationCookie2": "1 year",
        "descCookie3": "This cookie is installed by Google Analytics. The cookie is used to store information about how visitors use a website and to help us compile an analysis report on how the website is performing. The information collected includes the number of visitors, the source from which it originates, and the pages in anonymous form.",
        "durationCookie3": "1 day",
        "descCookie4": "This function incorporates a tracking script from the provider SalesViewer, which enables the attribution of an unknown user to his/her underlying company. SalesViewer® \
employs a JavaScript-based code which fulfils the function of highlighting company-related details and the corresponding utilisation. The data which is gathered by means of this technology is \
encrypted using a non-reversible one-way function ( “hashing”). The data is directly pseudonymised and is not used in order to achieve personal identification of the users of this website. \
However, there is identification of the user’s underlying company – to which it is subsequently possible to attribute the corresponding field and the details of the user’s specific actions on the \
website. ",
        "durationCookie4": "24 months",
        "showCookieInfo": "Cookie information",
        "showMoreInfo": "Display further information",
        "privacy": "Privacy",
        "impressum": "Imprint",
        "urlPrivacy": "https://otools.ktr.com/otools/DataprotectionEN.html",
        "urlImpressum": "https://www.ktr.com/en/service/imprint/?disabledOptIn=1",
    },
};
const DEFAULT_COOKIE_NAME = "ktr-cookie-compliance";
function checkCookie(cookiename) {
    var nameEQ = cookiename + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return c.substring(nameEQ.length, c.length);
    }
    return null;
}
;
function deleteAllCookies() {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++)
        deleteCookie(cookies[i].split("=")[0]);
}
function setCookie(name, value, expirydays) {
    var d = new Date();
    d.setTime(d.getTime() + (expirydays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + "; " + expires;
}
function deleteCookie(name) {
    setCookie(name, "", -1);
}
function getComplianceCookie(cookieName) {
    if (cookieName === undefined || cookieName === null) {
        cookieName = DEFAULT_COOKIE_NAME;
    }
    let cookieContent = checkCookie(cookieName);
    let complianceState = {
        Marketing: false,
        Standard: false,
        Analytics: false
    };
    if ((cookieContent !== null) || (cookieContent !== undefined)) {
        try {
            complianceState = JSON.parse(cookieContent);
        }
        catch (e) {
            deleteAllCookies();
        }
    }
    return complianceState;
}
exports.getComplianceCookie = getComplianceCookie;
const CookieBanner = (props) => {
    let lang = props.language;
    let cookieName = DEFAULT_COOKIE_NAME;
    if (props.cookiename !== undefined && props.cookiename !== null)
        cookieName = props.cookiename;
    let dropCookie = true;
    let cookieDuration = 364;
    const [showMe, setShowMe] = react_1.useState(true);
    let privacyLevelStandard = true;
    let privacyLevelAnalytics = false;
    let privacyLevelMarketing = false;
    react_1.useEffect(() => {
        let complianceCookie = getComplianceCookie(props.cookiename);
        if (complianceCookie === null
            || complianceCookie === undefined
            || complianceCookie.Standard === false
            || complianceCookie.Standard === undefined
            || complianceCookie.Standard === null) {
            setShowMe(true);
        }
        else {
            setShowMe(false);
        }
    }, []);
    function acceptAll(e) {
        const complianceState = {
            Analytics: true,
            Marketing: true,
            Standard: true
        };
        if (props.callbackCookieBannerClosed)
            props.callbackCookieBannerClosed(complianceState);
        createCookie(cookieName, JSON.stringify(complianceState), cookieDuration);
        setShowMe(false);
    }
    ;
    function acceptSave(e) {
        const complianceState = {
            Marketing: privacyLevelMarketing,
            Standard: privacyLevelStandard,
            Analytics: privacyLevelAnalytics
        };
        console.log("ACCEPT: privacyLevelStandard: " + privacyLevelStandard + ", " +
            "privacyLevelAnalytics: " + privacyLevelAnalytics + ", " +
            "privacyLevelMarketing: " + privacyLevelMarketing + ", ");
        if (props.callbackCookieBannerClosed) {
            props.callbackCookieBannerClosed(complianceState);
        }
        createCookie(cookieName, JSON.stringify(complianceState), cookieDuration);
        setShowMe(false);
    }
    ;
    function acceptEssential(e) {
        const complianceState = {
            Standard: true,
            Marketing: false,
            Analytics: false
        };
        createCookie(cookieName, JSON.stringify(complianceState), cookieDuration);
        setShowMe(false);
    }
    ;
    function createCookie(name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
        }
        else
            var expires = "";
        if (dropCookie) {
            document.cookie = name + "=" + value + expires + "; path=/";
        }
    }
    ;
    const eraseCookie = (name) => {
        createCookie(name, "", -1);
    };
    const handleCBClick = (e) => {
        console.log("START: target: " + e.target.id + " = " + e.target.checked);
        if (e.target.id === 'cbStandard') {
            privacyLevelStandard = e.target.checked;
        }
        if (e.target.id === 'cbAnalytics') {
            privacyLevelAnalytics = e.target.checked;
        }
        if (e.target.id === 'cbMarketing') {
            privacyLevelMarketing = e.target.checked;
        }
        console.log("ALL: privacyLevelStandard: " + privacyLevelStandard + ", " +
            "privacyLevelAnalytics: " + privacyLevelAnalytics + ", " +
            "privacyLevelMarketing: " + privacyLevelMarketing + ", ");
    };
    const toggleVisibilityDetailCookieList = (e) => {
        var el;
        var height = "200px";
        if (e.target.id === "showCookieInfo1") {
            el = document.getElementById("sg-cookie-optin-box-cookie-detail-sublist-1");
            height = "230px";
        }
        else if (e.target.id === "showCookieInfo2") {
            var el = document.getElementById("sg-cookie-optin-box-cookie-detail-sublist-2");
            var height = "850px";
        }
        else if (e.target.id === "showCookieInfo3") {
            var el = document.getElementById("sg-cookie-optin-box-cookie-detail-sublist-3");
            var height = "500px";
        }
        else
            return;
        if ((el === null) || (el.style === null) || (el.style.height === null) || (el.style.height.length == 0) || (el.style.height === ""))
            el.style.height = height;
        else
            el.style.height = "";
    };
    const toggleVisibilityDetailList = (e) => {
        var el = document.getElementById("sg-cookie-optin-box-cookie-detail-list-id");
        var cname = "sg-cookie-optin-visible";
        if (el.classList) {
            el.classList.toggle(cname);
        }
        else {
            var classes = el.className.split(" ");
            var i = classes.indexOf(cname);
            if (i >= 0)
                classes.splice(i, 1);
            else
                classes.push(cname);
            el.className = classes.join(" ");
        }
    };
    if (showMe !== true)
        return (react_1.default.createElement("div", null,
            props.googleAnalytics && props.googleAnalytics.googleAnalytics ?
                react_1.default.createElement(GAnalytics_1.default, { cookiename: props.cookiename, pagePath: props.googleAnalytics.googleAnalyticsPagePath })
                : "",
            props.salesViewer ?
                react_1.default.createElement(Salesviewer_1.default, { cookiename: props.cookiename })
                : ""));
    else
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { id: "SgCookieOptin" },
                react_1.default.createElement("div", { className: "sg-cookie-optin-box" },
                    react_1.default.createElement("strong", { className: "sg-cookie-optin-box-header" },
                        " ",
                        langBundle[lang]['title'],
                        " "),
                    react_1.default.createElement("p", { className: "sg-cookie-optin-box-description", dangerouslySetInnerHTML: { __html: langBundle[lang]['maintext'] } }),
                    react_1.default.createElement("ul", { className: "sg-cookie-optin-box-cookie-list" },
                        react_1.default.createElement("li", { className: "sg-cookie-optin-box-cookie-list-item" },
                            react_1.default.createElement("input", { className: "sg-cookie-optin-checkbox", type: "checkbox", id: "cbStandard", onChange: handleCBClick, checked: true, disabled: true }),
                            react_1.default.createElement("label", { className: "sg-cookie-optin-checkbox-label", htmlFor: 'cbStandard' },
                                " ",
                                react_1.default.createElement("span", null,
                                    " ",
                                    langBundle[lang]['essential'],
                                    " "),
                                " ")),
                        react_1.default.createElement("li", { className: "sg-cookie-optin-box-cookie-list-item" },
                            react_1.default.createElement("input", { className: "sg-cookie-optin-checkbox", type: "checkbox", id: "cbAnalytics", onChange: handleCBClick }),
                            react_1.default.createElement("label", { className: "sg-cookie-optin-checkbox-label", htmlFor: "cbAnalytics" },
                                " ",
                                react_1.default.createElement("span", null,
                                    " ",
                                    langBundle[lang]['statistics'],
                                    " "),
                                " ")),
                        react_1.default.createElement("li", { className: "sg-cookie-optin-box-cookie-list-item" },
                            react_1.default.createElement("input", { className: "sg-cookie-optin-checkbox", type: "checkbox", id: "cbMarketing", onChange: handleCBClick }),
                            react_1.default.createElement("label", { className: "sg-cookie-optin-checkbox-label", htmlFor: "cbMarketing" },
                                " ",
                                react_1.default.createElement("span", null,
                                    " ",
                                    langBundle[lang]['marketing'],
                                    " "),
                                " "))),
                    react_1.default.createElement("div", { className: "sg-cookie-optin-box-button" },
                        react_1.default.createElement("button", { className: "sg-cookie-optin-box-button-accept-all", onClick: acceptAll },
                            " ",
                            langBundle[lang]['acceptAll'],
                            " "),
                        react_1.default.createElement("button", { className: "sg-cookie-optin-box-button-accept-specific", onClick: acceptSave },
                            " ",
                            langBundle[lang]['acceptSave'],
                            " "),
                        react_1.default.createElement("button", { className: "sg-cookie-optin-box-button-accept-essential", onClick: acceptEssential },
                            " ",
                            langBundle[lang]['acceptEssential'],
                            " ")),
                    react_1.default.createElement("ul", { id: "sg-cookie-optin-box-cookie-detail-list-id", className: "sg-cookie-optin-box-cookie-detail-list" },
                        react_1.default.createElement("li", { className: "sg-cookie-optin-box-cookie-detail-list-item" },
                            react_1.default.createElement("strong", { className: "sg-cookie-optin-box-cookie-detail-header" },
                                " ",
                                langBundle[lang]['essential'],
                                " "),
                            react_1.default.createElement("p", { className: "sg-cookie-optin-box-cookie-detail-description", dangerouslySetInnerHTML: { __html: langBundle[lang]['descEssential'] } }),
                            react_1.default.createElement("div", { id: "sg-cookie-optin-box-cookie-detail-sublist-1", className: "sg-cookie-optin-box-cookie-detail-sublist" },
                                react_1.default.createElement("table", null,
                                    react_1.default.createElement("tbody", null,
                                        react_1.default.createElement("tr", { className: "divider" },
                                            react_1.default.createElement("td", { colSpan: "2" }, "\u00A0")),
                                        react_1.default.createElement("tr", null,
                                            react_1.default.createElement("th", null,
                                                " ",
                                                langBundle[lang]['name'],
                                                " "),
                                            react_1.default.createElement("td", null,
                                                " ",
                                                cookieName,
                                                " ")),
                                        react_1.default.createElement("tr", null,
                                            react_1.default.createElement("th", null,
                                                " ",
                                                langBundle[lang]['provider'],
                                                " "),
                                            react_1.default.createElement("td", null, "KTR Systems GmbH Carl-Zeiss-Stra\u00DFe 25 48432 Rheine Deutschland")),
                                        react_1.default.createElement("tr", null,
                                            react_1.default.createElement("th", null,
                                                " ",
                                                langBundle[lang]['duration'],
                                                " "),
                                            react_1.default.createElement("td", null,
                                                " ",
                                                langBundle[lang]['durationCookie1'],
                                                " ")),
                                        react_1.default.createElement("tr", null,
                                            react_1.default.createElement("th", null,
                                                " ",
                                                langBundle[lang]['goal'],
                                                " "),
                                            react_1.default.createElement("td", { className: "sg-cookie-optin-box-table-reason", dangerouslySetInnerHTML: { __html: langBundle[lang]['descCookie1'] } }))))),
                            react_1.default.createElement("a", { id: "showCookieInfo1", className: "sg-cookie-optin-box-sublist-open-more-link", href: "#", onClick: toggleVisibilityDetailCookieList },
                                " ",
                                langBundle[lang]['showCookieInfo'],
                                " ")),
                        react_1.default.createElement("li", { className: "sg-cookie-optin-box-cookie-detail-list-item" },
                            react_1.default.createElement("strong", { className: "sg-cookie-optin-box-cookie-detail-header" },
                                " ",
                                langBundle[lang]['statistics'],
                                " "),
                            react_1.default.createElement("p", { className: "sg-cookie-optin-box-cookie-detail-description", dangerouslySetInnerHTML: { __html: langBundle[lang]['descStatistics'] } }),
                            react_1.default.createElement("div", { id: "sg-cookie-optin-box-cookie-detail-sublist-2", className: "sg-cookie-optin-box-cookie-detail-sublist" },
                                react_1.default.createElement("table", null,
                                    react_1.default.createElement("tbody", null,
                                        react_1.default.createElement("tr", { className: "divider" },
                                            react_1.default.createElement("td", { colSpan: "2" }, "\u00A0")),
                                        react_1.default.createElement("tr", null,
                                            react_1.default.createElement("th", null,
                                                " ",
                                                langBundle[lang]['name'],
                                                " "),
                                            react_1.default.createElement("td", null, "Google Analytics")),
                                        react_1.default.createElement("tr", null,
                                            react_1.default.createElement("th", null,
                                                " ",
                                                langBundle[lang]['provider'],
                                                " "),
                                            react_1.default.createElement("td", null, "Google Ireland Ltd., Gordon House, Barrow Street, Dublin 4, Ireland, Fax: +353 (1) 436\u20091001")),
                                        react_1.default.createElement("tr", null,
                                            react_1.default.createElement("th", null,
                                                " ",
                                                langBundle[lang]['duration'],
                                                " "),
                                            react_1.default.createElement("td", null,
                                                " ",
                                                langBundle[lang]['durationCookie2'],
                                                " ")),
                                        react_1.default.createElement("tr", null,
                                            react_1.default.createElement("th", null,
                                                " ",
                                                langBundle[lang]['goal'],
                                                " "),
                                            react_1.default.createElement("td", { className: "sg-cookie-optin-box-table-reason", dangerouslySetInnerHTML: { __html: langBundle[lang]['descCookie2'] } }))))),
                            react_1.default.createElement("a", { id: "showCookieInfo2", className: "sg-cookie-optin-box-sublist-open-more-link", onClick: toggleVisibilityDetailCookieList, href: "#" },
                                " ",
                                langBundle[lang]['showCookieInfo'],
                                " ")),
                        react_1.default.createElement("li", { className: "sg-cookie-optin-box-cookie-detail-list-item" },
                            react_1.default.createElement("strong", { className: "sg-cookie-optin-box-cookie-detail-header" },
                                " ",
                                langBundle[lang]['marketing'],
                                " "),
                            react_1.default.createElement("p", { className: "sg-cookie-optin-box-cookie-detail-description", dangerouslySetInnerHTML: { __html: langBundle[lang]['descMarketing'] } }),
                            react_1.default.createElement("div", { id: "sg-cookie-optin-box-cookie-detail-sublist-3", className: "sg-cookie-optin-box-cookie-detail-sublist" },
                                react_1.default.createElement("table", null,
                                    react_1.default.createElement("tbody", null,
                                        react_1.default.createElement("tr", { className: "divider" },
                                            react_1.default.createElement("td", { colSpan: "2" }, "\u00A0")),
                                        react_1.default.createElement("tr", null,
                                            react_1.default.createElement("th", null,
                                                " ",
                                                langBundle[lang]['name'],
                                                " "),
                                            react_1.default.createElement("td", null, "SalesViewer")),
                                        react_1.default.createElement("tr", null,
                                            react_1.default.createElement("th", null,
                                                " ",
                                                langBundle[lang]['provider'],
                                                " "),
                                            react_1.default.createElement("td", null, "SalesViewer\u00AE GmbH, Bongardstra\u00DFe 29, 44787 Bochum, Email: in-fo@salesviewer.com")),
                                        react_1.default.createElement("tr", null,
                                            react_1.default.createElement("th", null,
                                                " ",
                                                langBundle[lang]['duration'],
                                                " "),
                                            react_1.default.createElement("td", null,
                                                " ",
                                                langBundle[lang]['durationCookie4'],
                                                " ")),
                                        react_1.default.createElement("tr", null,
                                            react_1.default.createElement("th", null,
                                                " ",
                                                langBundle[lang]['goal'],
                                                " "),
                                            react_1.default.createElement("td", { className: "sg-cookie-optin-box-table-reason", dangerouslySetInnerHTML: { __html: langBundle[lang]['descCookie4'] } }))))),
                            react_1.default.createElement("a", { id: "showCookieInfo3", className: "sg-cookie-optin-box-sublist-open-more-link", onClick: toggleVisibilityDetailCookieList, href: "#" },
                                " ",
                                langBundle[lang]['showCookieInfo'],
                                " "))),
                    react_1.default.createElement("div", { className: "sg-cookie-optin-box-open-more" },
                        react_1.default.createElement("a", { className: "sg-cookie-optin-box-open-more-link", href: "#", onClick: toggleVisibilityDetailList },
                            " ",
                            langBundle[lang]['showMoreInfo'],
                            " ")),
                    react_1.default.createElement("div", { className: "sg-cookie-optin-box-footer" },
                        react_1.default.createElement("div", { className: "sg-cookie-optin-box-footer-links" },
                            react_1.default.createElement("a", { className: "sg-cookie-optin-footer-box-link", href: langBundle[lang]['urlPrivacy'], target: '_blank' },
                                " ",
                                langBundle[lang]['privacy'],
                                " "),
                            react_1.default.createElement("span", { className: "sg-cookie-optin-footer-box-divider" }, " | "),
                            react_1.default.createElement("a", { className: "sg-cookie-optin-footer-link", href: langBundle[lang]['urlImpressum'], target: '_blank' },
                                " ",
                                langBundle[lang]['impressum'],
                                " ")))))));
};
exports.default = CookieBanner;
//# sourceMappingURL=CookieBanner.js.map